import React, { useContext, useState } from "react";
import { CartContext } from "../../context/CartContext";
import { Card, Row, Col, Button, Typography, message,Modal,Radio } from "antd";
import SummaryApi from "../../common/index";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import "../../Styles/UserStylings/CartPage.css";
 
const { Title, Text } = Typography;
 
const CartPage = () => {
  const { cart, updateCartItem, removeFromCart } = useContext(CartContext);
  const [selectedProductId, setSelectedProductId] = useState(null);
  const [isPaymentModalVisible, setIsPaymentModalVisible] = useState(false);
const [paymentMethod, setPaymentMethod] = useState("online");
  const navigate = useNavigate();
  const BASE_URL = process.env.REACT_APP_BACKEND_URL;
  const defaultImage = "/images/default_product.jpg";
  if (cart.length === 0)
    return (
      <div className="cart-empty">
        <Title level={3}>Your cart is empty</Title>
        <p>Add products to get started!</p>
      </div>
    );
 
  const total = selectedProductId
    ? (() => {
        const item = cart.find((i) => i.id === selectedProductId);
        return item ? item.quantity * (item.product?.price || 0) : 0;
      })()
    : cart.reduce((sum, item) => sum + item.quantity * (item.product?.price || 0), 0);
 
  const handlePayAtStore = async () => {
  try {
    const token = localStorage.getItem("token");
    const itemsToPay = selectedProductId
      ? cart.filter(item => item.id === selectedProductId)
      : cart;

    if (!itemsToPay.length) return message.warning("No items selected!");

    const totalAmount = Number(
      itemsToPay
        .reduce((sum, item) => sum + item.quantity * (item.product?.price || 0), 0)
        .toFixed(2)
    );

    const orderItems = itemsToPay.map(item => ({
      product_id: item.product.id,
      quantity: item.quantity,
      price: item.product.price,
    }));

    const { data } = await axios.post(
      SummaryApi.payAtStore.url,
      { items: orderItems ,payment_method:"pay_at_store"},
      { headers: { Authorization: `Bearer ${token}` } }
    );

    if (data.success) {
      message.success("Order placed successfully! Pay at store.");
      const purchasedIds = itemsToPay.map(item => item.id);
      purchasedIds.forEach(id => removeFromCart(id));
      navigate("/confirmation", {
        state: { 
          cart: itemsToPay,                  // full cart items
    total: totalAmount,                // total amount
    paymentType: "Pay at Store",       // method
    paymentId: null,                   // no paymentId for store
    orderId: data.orderId || "-",  
     orderNumber: data.orderNumber || "-",    // order id from backend
    date: new Date().toLocaleString(), 
   },
      });
    } else {
      message.error(data.message || "Failed to create order");
    }
  } catch (error) {
    console.error("Pay at Store error:", error);
    message.error("Something went wrong while placing your order");
  }
};

  const handleCheckout = async () => {
    try {
      const token = localStorage.getItem("token");
      const itemsToPay = selectedProductId
        ? cart.filter((item) => item.id === selectedProductId)
        : cart;
      // 🔥 Stock Validation before payment
for (const item of itemsToPay) {
  const maxStock = item.product.stock;
  if (item.quantity > maxStock) {
    return message.error(
      `${item.product.name} has only ${maxStock} left in stock Sorry for the inconvenience.`
    );
  }
}

      if (!itemsToPay.length) {
        message.warning("No products selected for payment!");
        return;
      }
      const totalAmount = Number(
        itemsToPay
          .reduce((sum, item) => sum + item.quantity * (item.product?.price || 0), 0)
          .toFixed(2)
      );
      if (totalAmount <= 0) {
        message.warning("Cart is empty!");
        return;
      }
      const orderItems = itemsToPay.map(item => ({
        product_id: item.product.id,
        quantity: item.quantity,
        seller_id: item.product.seller.id,
        price: item.product.price,
        brand: item.product.brand,
      }));
 
      const { data } = await axios.post(
        SummaryApi.createOrder.url,
        { amount: totalAmount, items: orderItems ,payment_method: "online"},
        {
          headers: { Authorization: `Bearer ${token}` },
          withCredentials: true,
        }
      );
      const razorpayOrder = data.razorpayOrder;
      const dbOrderId = data.orderId;
      const totalAmountFromBackend = data.totalAmount;
 
      if (!razorpayOrder || !dbOrderId || !totalAmountFromBackend) {
        message.error("Order creation failed!");
        return;
      }
      const loadScript = (src) =>
        new Promise((resolve) => {
          const script = document.createElement("script");
          script.src = src;
          script.onload = () => resolve(true);
          script.onerror = () => resolve(false);
          document.body.appendChild(script);
        });
 
      const resRazor = await loadScript("https://checkout.razorpay.com/v1/checkout.js");
      if (!resRazor) {
        message.error("Razorpay SDK failed to load");
        return;
      }
      const options = {
       
        key: process.env.REACT_APP_RAZORPAY_KEY_ID,
        amount: Math.round(totalAmountFromBackend * 100),
        currency: "INR",
        name: "Book Local",
        description: "Payment for your order",
        order_id: razorpayOrder.id,
        handler: async function (response) {
          try {
            const orderItems = itemsToPay.map(item => ({
              product_id: item.product.id,
              quantity: item.quantity,
              seller_id: item.product.seller?.id,
            }));
            const verifyRes = await axios.post(
              SummaryApi.verifyPayment.url,
              {
                razorpay_order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature,
                products: orderItems,
              },
              { headers: { Authorization: `Bearer ${token}` }, withCredentials: true }
            );
            if (verifyRes.data.success) {
  message.success("Payment successful!");
    console.log("Payment verification response:", verifyRes.data);
    console.log("razorpay key:", process.env.REACT_APP_RAZORPAY_KEY_ID);
  // Remove purchased items from cart state immediately
  const purchasedIds = itemsToPay.map(item => item.id);
  purchasedIds.forEach(id => removeFromCart(id)); // Calls context function

  // Reset selected product
  setSelectedProductId(null);

  // Navigate to confirmation page
  navigate("/confirmation", {
    state: {
      ...verifyRes.data,
      cart: itemsToPay,
      total: totalAmount,
      date: new Date().toLocaleString(),
    },
  });
}
 else {
              message.error("Payment verification failed!");
              navigate("/cancel", {
                state: { orderId: dbOrderId, total: totalAmountFromBackend, date: new Date().toLocaleString() },
              });
            }
          } catch (err) {
            console.error("Payment verification error:", err);
            message.error("Payment verification failed!");
          }
        },
        // prefill and notes are fine to include in this way; they do not restrict the UI
        prefill: {
          name: "Customer Name",
          email: "customer@example.com",
          contact: "9876543210",
        },
        notes: {
          address: "Customer Address",
        },
        theme: {
          color: "#1129ce",
        },
        modal: {
          ondismiss: function () {
            navigate("/cancel", {
              state: { orderId: dbOrderId, total: totalAmountFromBackend, date: new Date().toLocaleString() },
            });
          },
        },
      };
      const paymentObject = new window.Razorpay(options);
      paymentObject.open();
    } catch (error) {
      console.error("Checkout error:", error);
      message.error("Something went wrong during checkout");
    }
  };
 
  return (
    <div className="cart-page-container" style={{ padding: 16, background: "#fafcff", minHeight: "100vh" }}>
      <Title level={2} className="cart-page-title" style={{ textAlign: "center", marginBottom: 32 }}>
        My Cart
      </Title>
      <Row gutter={[24, 24]}>
        {/* Left: Scrollable Cart Items */}
        <Col xs={24} lg={16}>
          <div className="cart-items-container">
            {cart.map(item => (
              <Card
                key={item.id}
                className="cart-item-card"
                bodyStyle={{ padding: 18 }}
                style={{
                  marginBottom: 24,
                  borderRadius: 14,
                  border: "1px solid #e6e6e6",
                  boxShadow: "0 1px 6px rgba(24,144,255,0.04)",
                }}
              >
                <Row align="middle" gutter={24}>
                  <Col xs={24} sm={6} style={{ display: "flex", alignItems: "center" }}>
                    <img
                      src={`${BASE_URL}${item.product.image}`}
                      alt={item.product.name}
                      style={{
                        width: 80,
                        height: 80,
                        objectFit: "contain",
                        borderRadius: 10,
                        background: "#fffffa",
                        border: "1px solid #eaeaea",
                        marginBottom: 10
                      }}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = defaultImage;
                        }}
                    />
                  </Col>
                  <Col xs={24} sm={10}>
                    <h3 style={{ marginBottom: 6, fontWeight: 500 }}>{item.product.name}</h3>
                    <Text type="secondary">{item.product.brand}</Text>
                    <div style={{ fontWeight: 600, marginTop: 8 }}>₹{item.product.price}</div>
                    <div style={{ marginTop: 8, fontWeight: 600, color: "#1866ff" }}>
                      Subtotal: ₹{item.quantity * item.product.price}
                    </div>
                  </Col>
                  <Col xs={24} sm={8} style={{ textAlign: "center" }}>
                    <div className="quantity-selector" style={{ marginBottom: 12,display: "flex", justifyContent: "center", alignItems: "center"}}>
                      <Button
                        onClick={() => updateCartItem(item.id, item.quantity - 1)}
                        disabled={item.quantity <= 1}
                        style={{ marginRight: 6, borderRadius: "50%" }}
                      >-</Button>
                      <span style={{ margin: "0 10px", fontWeight: 600 }}>{item.quantity}</span>
                      <Button
                      onClick={() => {
  const maxStock = item.product.stock;     // ⬅️ backend stock
  if (item.quantity + 1 > maxStock) {
    return message.warning(`Only ${maxStock} items in stock We apologize for the inconvenience.`);
  }
  updateCartItem(item.id, item.quantity + 1);
}}

                        style={{ borderRadius: "50%" }}
                      >+</Button>
                    </div>
                    <Button
                      type="primary"
                      block
                      style={{
                        background: "#1129ce",
                        borderColor: "#1129ce",
                        fontWeight: 600,
                        marginBottom: 6,
                        borderRadius: 8
                      }}
                      onClick={() => setSelectedProductId(item.id)}
                    >
                      Buy Now
                    </Button>
                    <Button
                      type="primary"
                      danger
                      block
                      style={{
                        background: "#ee152d",
                        borderColor: "#ee152d",
                        fontWeight: 600,
                        borderRadius: 8
                      }}
                      onClick={() => removeFromCart(item.id)}
                    >
                      Remove
                    </Button>
                  </Col>
                </Row>
              </Card>
            ))}
          </div>
        </Col>
        {/* Right: Sticky Cart Summary */}
        <Col xs={24} lg={8}>
          <Card
            className="cart-summary-card"
            style={{
              position: "sticky",
              top: 32,
              borderRadius: 14,
              background: "#fff",
              boxShadow: "0 4px 24px rgba(24, 102, 255, 0.07)",
              border: "1.5px solid #1129ce"
            }}
          >
            <h4 style={{ marginBottom: 20, color: "#172839", fontWeight: 600, textAlign: "center" }}>
              Cart Summary
            </h4>
            <div style={{ marginBottom: 16, fontSize: 16 }}>
              <div>
                Total Items:&nbsp;
                <span style={{ fontWeight: 700 }}>
                  {selectedProductId
                    ? cart.find(i => i.id === selectedProductId)?.quantity
                    : cart.reduce((sum, i) => sum + i.quantity, 0)}
                </span>
              </div>
              <div>
                Total Price:&nbsp;
                <span style={{ fontWeight: 700, color: "#1129ce" }}>₹{total}</span>
              </div>
            </div>
            {selectedProductId && (
              <div style={{ marginBottom: 14, background: "#fffffa", padding: 12, borderRadius: 10 }}>
                <h5>Selected Item:</h5>
                <div>{cart.find(i => i.id === selectedProductId)?.product.name}</div>
                <div style={{ fontWeight: 600 }}>
                  Qty: {cart.find(i => i.id === selectedProductId)?.quantity} x ₹{cart.find(i => i.id === selectedProductId)?.product.price} = ₹
                  {cart.find(i => i.id === selectedProductId)?.quantity * cart.find(i => i.id === selectedProductId)?.product.price}
                </div>
                <Button
                  block
                  style={{ marginTop: 10, background: "#1129ce", color: "#fffffa", borderRadius: 8, fontWeight: 500 }}
                  onClick={() => setSelectedProductId(null)}
                >
                  Show All
                </Button>
              </div>
            )}
            <Button
              type="primary"
              block
              style={{
                background: "#1129ce",
                borderColor: "#1129ce",
                fontWeight: 600,
                borderRadius: 10,
                height: 44,
                fontSize: 18,
                marginTop: 12
              }}
             onClick={() => setIsPaymentModalVisible(true)}
            >
              Proceed to Checkout
            </Button>
          </Card>
        </Col>
      </Row>
      <Modal
  title="Select Payment Method"
  open={isPaymentModalVisible}
  onCancel={() => setIsPaymentModalVisible(false)}
  footer={[
    <Button key="cancel" onClick={() => setIsPaymentModalVisible(false)}>
      Cancel
    </Button>,
    <Button
      key="proceed"
      type="primary"
      onClick={() => {
        setIsPaymentModalVisible(false);
        if (paymentMethod === "store") handlePayAtStore();
        else handleCheckout();
      }}
    >
      Proceed
    </Button>,
  ]}
>
  <Radio.Group
    onChange={(e) => setPaymentMethod(e.target.value)}
    value={paymentMethod}
    style={{ display: "flex", flexDirection: "column", gap: 10, marginTop: 10 }}
  >
    <Radio value="online">💳 Pay Online (Razorpay)</Radio>
    <Radio value="store">🏪 Pay at Store</Radio>
  </Radio.Group>
</Modal>

    </div>
  );
};
 
export default CartPage;
